import { getCompanyBankDetailListQueryKey } from "Company/Modules/BankDetail/Api/Query/useCompanyBankDetailListQuery";
import {
	type CompanyBankDetailUpdateDto,
	patchCompanyCompanyIdBankDetailId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const bankDetailMutationsResource = Resources.base.bankDetail.mutations;

export const useUpdateCompanyBankDetailMutation = (
	bankDetailId: number,
	companyId: number,
) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: CompanyBankDetailUpdateDto) =>
			patchCompanyCompanyIdBankDetailId(data, companyId, bankDetailId),
		),
		onError: (error) => {
			console.error(
				`${t(bankDetailMutationsResource.updateBankDetailError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(t(bankDetailMutationsResource.updateBankDetailSuccess));
			queryClient.invalidateQueries({
				queryKey: getCompanyBankDetailListQueryKey(companyId),
			});
		},
	});
};
